import React, { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import logo from '../assets/logo.png';
import './Header.css';

const navLinks = [
  { to: '/',           label: 'Início'        },
  { to: '/quem-somos', label: 'Quem Somos'    },
  { to: '/projetos',   label: 'Projetos'      },
  { to: '/noticias',   label: 'Notícias'      },
  { to: '/galeria',    label: 'Galeria'        },
  { to: '/documentos', label: 'Transparência' },
  { to: '/contato',    label: 'Contato'       },
];

export default function Header() {
  const [open,    setOpen]    = useState(false);
  const [scrolled,setScrolled]= useState(false);
  const { isAdmin }           = useAuth();
  const location              = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location]);

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="header-inner container">

        {/* ── Logo ── */}
        <Link to="/" className="header-logo">
          <img src={logo} alt="Instituto Mãos Estendidas" className="header-logo-img" />
          <div className="logo-text">
            <span className="logo-instituto">Instituto</span>
            <span className="logo-nome">Mãos Estendidas</span>
          </div>
        </Link>

        {/* ── Nav desktop ── */}
        <nav className="header-nav">
          {navLinks.map(l => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === '/'}
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        {/* ── Ações ── */}
        <div className="header-actions">
          {isAdmin
            ? <Link to="/admin" className="btn btn-outline btn-sm">⚙ Painel</Link>
            : <Link to="/admin/login" className="btn-admin-acesso" title=".">Área Admin</Link>
          }
          <Link to="/contato" className="btn btn-primary btn-sm">Fale conosco</Link>
          <button className="menu-btn" onClick={() => setOpen(o => !o)} aria-label="Menu">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* ── Menu mobile ── */}
      <div className={`mobile-menu ${open ? 'open' : ''}`}>
        {navLinks.map(l => (
          <NavLink
            key={l.to}
            to={l.to}
            end={l.to === '/'}
            className={({ isActive }) => `mobile-link ${isActive ? 'active' : ''}`}
          >
            {l.label}
          </NavLink>
        ))}
        <div className="mobile-divider" />
        {isAdmin
          ? <Link to="/admin" className="mobile-link mobile-link-admin">⚙ Painel Administrativo</Link>
          : <Link to="/admin/login" className="mobile-link mobile-link-admin">🔒 .</Link>
        }
      </div>
    </header>
  );
}